// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"117":"f985f2fb","453":"006b72a6","480":"83143954","495":"a449cdeb","656":"f2d6e36d","784":"9244cae4","844":"b982ec13","971":"dd949aed"}[chunkId] + ".chunk.js";
};